/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Article_MetaInputs */

const en_funnel_demo_article_meta = /** @type {(inputs: Funnel_Demo_Article_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample article`)
};

const es_funnel_demo_article_meta = /** @type {(inputs: Funnel_Demo_Article_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículo de ejemplo`)
};

/**
* | output |
* | --- |
* | "Sample article" |
*
* @param {Funnel_Demo_Article_MetaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_article_meta = /** @type {((inputs?: Funnel_Demo_Article_MetaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Article_MetaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_article_meta(inputs)
	return en_funnel_demo_article_meta(inputs)
});